import { type RouteObject, RouterProvider, createBrowserRouter } from 'react-router-dom';
import { CostCalculatorLandingView } from 'src/admin/views/CostCalculatorLandingView';
import { ErrorPage } from 'src/components/ErrorPage';

const costCalculatorRoutes: Array<RouteObject> = [
  {
    path: '/cost-calculator/:product',
    element: <CostCalculatorLandingView />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/cost-calculator',
    element: <CostCalculatorLandingView />,
    errorElement: <ErrorPage />,
  },
];

const router = createBrowserRouter(costCalculatorRoutes);

export const CostCalculatorRouter = () => {
  return <RouterProvider router={router} />;
};
